import { isStrictBridgeOrigin, resolveBridgeOrigin } from '@web-studio/shared-schemas';

const DEV_SHELL_ORIGIN = 'http://localhost:3000';
const DEV_LOCALHOST_ORIGIN = /^https?:\/\/localhost:\d+$/;

let cachedShellOrigin: string | null = null;

function getConfiguredShellOrigin(): string {
  if (!cachedShellOrigin) {
    cachedShellOrigin = resolveBridgeOrigin({
      envValue: import.meta.env.VITE_SHELL_ORIGIN,
      envName: 'VITE_SHELL_ORIGIN',
      isProduction: import.meta.env.PROD,
      devFallback: DEV_SHELL_ORIGIN,
    });
  }
  return cachedShellOrigin;
}

/** Canonical studio-shell origin from env (production and dev default). */
export function resolveConfiguredShellOrigin(): string {
  return getConfiguredShellOrigin();
}

function resolveDevShellOriginFromReferrer(): string | null {
  if (import.meta.env.PROD || typeof document === 'undefined') {
    return null;
  }
  try {
    const referrer = document.referrer;
    if (!referrer) {
      return null;
    }
    const origin = new URL(referrer).origin;
    return DEV_LOCALHOST_ORIGIN.test(origin) ? origin : null;
  } catch {
    return null;
  }
}

/**
 * Target origin for sandbox → shell postMessage.
 * In dev, prefer the embedding studio tab (handles Next.js port fallback).
 */
export function resolveShellPostMessageTarget(): string {
  return resolveDevShellOriginFromReferrer() ?? resolveConfiguredShellOrigin();
}

/** Strict inbound gate — shell → sandbox postMessage listener. */
export function isAllowedShellOrigin(origin: string): boolean {
  if (isStrictBridgeOrigin(origin, getConfiguredShellOrigin())) {
    return true;
  }
  if (!import.meta.env.PROD && DEV_LOCALHOST_ORIGIN.test(origin)) {
    return true;
  }
  return false;
}
